import { render, staticRenderFns } from "./LmProcessTypesNewOrEdit.vue?vue&type=template&id=38a7e4b7&scoped=true&"
import script from "./LmProcessTypesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmProcessTypesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessTypesNewOrEdit.vue?vue&type=style&index=0&id=38a7e4b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7e4b7",
  null
  
)

export default component.exports